import { Descriptions, Drawer } from 'antd';
import React from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { getEmailDetails } from '../../api/settings/email-template.js';

const EmailDetails = () => {
    const { email } = useLoaderData()
    const navigate = useNavigate()
    const emailPreviewStyles = {
        width: '100%',
        minHeight: 500,
        border: 0,
    }

    return (
        <Drawer size="large" open={true} mask={false} title="Email Details" onClose={() => navigate('..', { replace: true, relative: 'route' })} >
            <Descriptions column={1} bordered={true} layout="vertical">
                <Descriptions.Item label="Suibject">{email.subject}</Descriptions.Item>
                <Descriptions.Item label="Body">
                    <iframe
                        title="Email body preview"
                        sandbox=""
                        referrerPolicy="no-referrer"
                        srcDoc={email.message}
                        style={emailPreviewStyles}
                    />
                </Descriptions.Item>
            </Descriptions>
        </Drawer >
    )
}

EmailDetails.Loader = async ({ params }) => {
    const { id, emailId } = params
    const email = await getEmailDetails(id, emailId)
    return { email }
}

export default EmailDetails






